import React from 'react'
import RowQAApproveAction from 'tennders-market/bin/components/row/action/RowQAApproveAction'
import RowAssignBrokerAction from 'tennders-market/bin/components/row/action/RowAssignBrokerAction'
import RowAssignTrackerAction from 'tennders-market/bin/components/row/action/RowAssignTrackerAction'
import DetailHeader from './DetailHeader'

const MatchedDetailView = ({ transaction, broker, close }) => (
  transaction ? (
    <DetailHeader
      transaction={transaction}
      item={transaction.matchedLoad || transaction.matchedTruck}
      close={close}
    >
      {broker && (window.location.href.slice(-2) === 'qc'
        ? <RowQAApproveAction transaction={transaction} color="white" closeTransaction={close} />
        : (!transaction?.matchedTruck?.isMarketPlaced && (
          <>
            <RowAssignBrokerAction transaction={transaction} />
            <div className="pr-10" />
            <RowAssignTrackerAction transaction={transaction} />
          </>
        ))
      )}
    </DetailHeader>
  ) : null
)

export default React.memo(MatchedDetailView)
